module.exports = __webpack_public_path__ + "static/media/012.cee64709.jpg";